var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("app-detail-header", {
        attrs: {
          "show-toggle": true,
          "show-delete": false,
          "show-save": false,
          "show-cancel": false,
          "show-new": false,
          "show-advance-payment-entry": true,
        },
        on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
      }),
      _c("div", { staticClass: "columns is-gapless" }, [
        _c(
          "div",
          { staticClass: "column is-narrow" },
          [
            _c("payment-entry-list-side-menu", {
              on: { filter: _vm.filterList, reset: _vm.resetList },
              model: {
                value: _vm.filter,
                callback: function ($$v) {
                  _vm.filter = $$v
                },
                expression: "filter",
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "column" }, [
          _c("div", { staticClass: "tile is-parent" }, [
            _c(
              "article",
              { staticClass: "tile is-child box" },
              [
                _c(
                  "bulma-table",
                  {
                    staticClass:
                      "table is-bordered is-striped is-narrow is-fullwidth",
                    attrs: {
                      columns: _vm.columns,
                      "page-index": _vm.filter.pageIndex,
                      "page-size": _vm.filter.pageSize,
                      "total-rows": _vm.totalRows,
                      "is-loading": _vm.isTableLoading,
                      "sort-column": _vm.filter.sortColumn,
                      "sort-order": _vm.filter.sortOrder,
                    },
                    on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
                  },
                  [
                    _vm._l(_vm.entitySummaries, function (entity, index) {
                      return _c(
                        "tr",
                        {
                          key: entity.creditorInvoiceId,
                          class: { "is-selected": _vm.selectedRow === index },
                          on: {
                            click: function ($event) {
                              return _vm.highlightSelected(index, $event)
                            },
                          },
                        },
                        [
                          _c("td", [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.generateUrl(entity.vendorId),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.addNew(entity.vendorId, $event)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(entity.invoiceRef))]
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(entity.vendorName))]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatDateTimezone(
                                  entity.invoiceDate,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatDateTimezone(
                                  entity.due,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  entity.balance,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  entity.totalAmount,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  entity.gstAmount,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", { staticClass: "has-text-right" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$filters.formatNumber(
                                  entity.amount,
                                  _vm.$userInfo.locale
                                )
                              )
                            ),
                          ]),
                          _c("td", [_vm._v(_vm._s(entity.quoteNoRef))]),
                          _c("td", { staticClass: "has-text-centered" }, [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "button is-primary is-small is-inverted tooltip",
                                attrs: {
                                  href: _vm.generateUrl(entity.vendorId),
                                  "data-tooltip": "Payment",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.addNew(entity.vendorId)
                                  },
                                },
                              },
                              [
                                _c("span", { staticClass: "icon is-medium" }, [
                                  _c("i", {
                                    staticClass:
                                      "mdi mdi-currency-usd mdi-24px",
                                  }),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                    _c("template", { slot: "empty" }, [
                      _c("section", { staticClass: "section" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "content has-text-grey has-text-centered",
                          },
                          [
                            _c("span", { attrs: { icon: "icon is-large" } }, [
                              _c("i", {
                                staticClass: "mdi mdi-48px mdi-emoticon-sad",
                              }),
                            ]),
                            _c("p", [_vm._v("Nothing")]),
                          ]
                        ),
                      ]),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("vue-fab", {
        attrs: {
          position: "bottom-right",
          "z-index": 30,
          actions: _vm.fabActions,
          "main-tooltip": "Payment Entry Actions",
        },
        on: { advancePayment: _vm.advancePayment },
      }),
      _vm.isAdvancePaymentModalActive
        ? _c("payment-entry-advance-payment-modal", {
            attrs: { active: _vm.isAdvancePaymentModalActive },
            on: {
              "update:active": function ($event) {
                _vm.isAdvancePaymentModalActive = $event
              },
              close: _vm.closeAdvancePaymentModal,
            },
            model: {
              value: _vm.entitySummaries,
              callback: function ($$v) {
                _vm.entitySummaries = $$v
              },
              expression: "entitySummaries",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }